import * as React from "react";

import ClassNames from "classnames";
import Styles from "./Card.module.css";

import Button from "../Button";
import Typography from "../Typography";

export interface Props {
  featuredImage?: string;
  featuredImageDescription?: string;
  title?: string;
  text?: string;
  variant?: "horizontal" | "vertical";
  button?: boolean;
  buttonClass?: string;
  buttonText?: string;
}

const Card: React.FC<Props> = props => {
  const {
    variant = "vertical",
    featuredImage,
    featuredImageDescription = "Preview",
    title,
    text,
    button,
    buttonText,
    buttonClass
  } = props;

  const variantClass = variant !== "vertical";

  return (
    <div
      className={ClassNames({
        [Styles.card]: true,
        [Styles[variant]]: variantClass
      })}
    >
      {featuredImage && (
        <div
          className={ClassNames({
            [Styles.imageContainer]: true,
            [Styles[variant]]: variantClass
          })}
        >
          <img
            src={featuredImage}
            className={Styles.image}
            alt={featuredImageDescription}
          />
        </div>
      )}
      <div
        className={ClassNames({
          [Styles.textContainer]: true,
          [Styles[variant]]: variantClass
        })}
      >
        {title && (
          <Typography variant="h4" className={Styles.title}>
            {title}
          </Typography>
        )}
        {text && <Typography className={Styles.text}>{text}</Typography>}
      </div>
      {button && (
        <Button
          className={ClassNames({
            [Styles.button]: true,
            [buttonClass]: buttonClass
          })}
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
};

export default Card;
